import { keysToCamelCase } from '@hotjar/insights-common/lib/convert-string/toCamelCase';
import type {
  EngageAccountAdmin,
  EngageAccountAdminDto,
  PPUserStatusResponse,
  PPUserStatusResponseDto,
} from './types';

export const ppUserStatusDtoToModel = (response: PPUserStatusResponseDto): PPUserStatusResponse =>
  keysToCamelCase(response);

export const engageAccountAdminDtoToModel = (response: EngageAccountAdminDto): EngageAccountAdmin =>
  keysToCamelCase(response);
